import { render, staticRenderFns } from "./MarkTypesPicker.vue?vue&type=template&id=48872f8d&lang=pug&"
import script from "./MarkTypesPicker.vue?vue&type=script&lang=js&"
export * from "./MarkTypesPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports